import type { IPopoverManager } from '@@commons';
import type { IVisualConfigurationStateManager } from '@@components/visualconfig';

export function editText(popovermgr: IPopoverManager,
    text, visualConfigurationState?: IVisualConfigurationStateManager):Promise<string> {
    return import(/* webpackChunkName: "modrichtext" */ './richtexteditormodal').then((mod) => {
        return mod.editText(popovermgr, text, visualConfigurationState);
    });
}
